module.exports = __webpack_public_path__ + "static/img/YORK老师_Edwin.2b494f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK老师_Edwin.png
// module id = sCFq
// module chunks = 0